

























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import {FieldStyleContext} from '@/fields/field-style-context';

/**
 * General Component for Fields of type SWITCH
 *
 * https://confluence.ametras.com/x/L4RQAw
 */
@Component({
  mixins: [BindAttrs]
})
export default class AmetrasSwitchTemplate extends Vue {
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';
  @Prop() value!: string | number | boolean | null | undefined;
  @Prop() label!: string;
  /**
   * Indicates that we should render a simple mode of this component (increases the rendering performance)
   */
  @Prop() simple!: boolean;
  @Prop() readonly!: boolean;
  @Prop() loading!: boolean;
  @Prop() styleContext!: FieldStyleContext;

  innerValue: boolean = false;

  @Watch('value') valueChanged(newValue: string | number | boolean | null | undefined) {
    if (newValue !== '') {
      this.innerValue = this.primitiveToBoolean(newValue);
    }
  }

  @Watch('innerValue') innerValueChanged(newValue: boolean) {
    if (newValue !== this.primitiveToBoolean(this.value)) {
      // publish only if different
      this.$emit('input', newValue);
    }
  }

  created() {
    this.innerValue = this.primitiveToBoolean(this.value);
  }

  primitiveToBoolean(value: string | number | boolean | null | undefined): boolean {
    if (value === 'true') {
      return true;
    }

    return typeof value === 'string'
        ? !!+value   // we parse string to integer first
        : !!value;
  }
}
